"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FloatingMenuAlert_1 = require("./FloatingMenuAlert");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return FloatingMenuAlert_1.default; } });
